import PropTypes from 'prop-types';
import React from 'react';
import { FormControl, FormGroup, InputGroup, Button } from 'react-bootstrap';
import ModeInputHelperText from './ModeInputHelperText.react';

export default class PercentageOptions extends React.Component {
  constructor(props) {
    super(props);
    this.onPercentageChange = this.onPercentageChange.bind(this);
    this.selectMax = this.selectMax.bind(this);
    this.selectExact = this.selectExact.bind(this);
  }

  onPercentageChange(e) {
    const newPercentage = e.target.value.replace(/[^.0-9]+/g, '');
    this.props.updatePercentage(newPercentage);
    if (newPercentage === '') {
      this.props.updatePercentageType('');
    }
  }

  selectMax() {
    this.props.updatePercentageType('max');
  }

  selectExact() {
    this.props.updatePercentageType('exact');
  }

  render() {
    return (
      <FormGroup className='budget-constraint-group percent-constraint'>
        <InputGroup>
          <InputGroup.Button>
            <Button
              onClick={this.selectMax}
              disabled={!this.props.mode.selected}
              active={this.props.mode.percentageType === 'max'}
            >At Most</Button>
            <Button
              onClick={this.selectExact}
              disabled={!this.props.mode.selected}
              active={this.props.mode.percentageType === 'exact'}
            >Exactly</Button>
          </InputGroup.Button>
          <FormControl
            type='text'
            value={this.props.mode.percentage}
            onChange={this.onPercentageChange}
            disabled={!this.props.mode.selected}
          />
          <InputGroup.Addon>%</InputGroup.Addon>
        </InputGroup>
        <ModeInputHelperText
          text={this.props.mode.percentText}
          tooltip={this.props.mode.percentTooltip}
          wide
        />
      </FormGroup>
    );
  }
}

PercentageOptions.propTypes = {
  mode: PropTypes.object,
  updatePercentage: PropTypes.func,
  updatePercentageType: PropTypes.func,
};
